import { render, staticRenderFns } from "./TransactionSummary.vue?vue&type=template&id=325a9bd2&scoped=true"
import script from "./TransactionSummary.vue?vue&type=script&lang=js"
export * from "./TransactionSummary.vue?vue&type=script&lang=js"
import style0 from "./TransactionSummary.vue?vue&type=style&index=0&id=325a9bd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325a9bd2",
  null
  
)

export default component.exports